// extracted by mini-css-extract-plugin
export default {"botao":"PaginaBase_botao__uNkCw","aparece":"PaginaBase_aparece__2VJNr"};